import React, { useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";


// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import { getUserRoleFromToken } from "../../helpers/auth_token_helper"
import { useStore } from "../../contexts/StoreContext"
import { canStorePublishBags } from "../../helpers/store_access_helper"

const SidebarContent = props => {
  const ref = useRef();
  const role = getUserRoleFromToken();
  const { store } = useStore()
  const canPublishBags = canStorePublishBags(store)
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {
              ('admin' === role || 'manager' === role) && (
                <li>
                  <Link to="/dashboard">
                    <i className="bx bx-home-circle"></i>
                    <span>{props.t("Tableau de board")}</span>
                  </Link>
                </li>
              )
            }

            <li>
              <Link to="/bags">
                <i className="bx bx-package"></i>
                <span>{props.t("Paniers")}</span>
              </Link>
            </li>

            {canPublishBags && (
              <>
                <li>
                  <Link to="/schedule">
                    <i className="bx bx-time"></i>
                    <span>{props.t("Planificateur des collectes")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/calendar">
                    <i className="bx bx-calendar"></i>
                    <span>{props.t("Calendrier")}</span>
                  </Link>
                </li>
              </>
            )}

            <li>
              <Link to="/sales">
                <i className="bx bx-credit-card"></i>
                <span>{props.t("Ventes")}</span>
              </Link>
            </li>

            {
              ('admin' === role || 'manager' === role) && (
                <>
                  <li>
                    <Link to="/store-settings">
                      <i className="bx bx-store"></i>
                      <span>{props.t("Paramètres du magasin")}</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/users-access">
                      <i className="bx bx-user"></i>
                      <span>{props.t("Utilisateurs et Accès")}</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/feedback-reviews">
                      <i className="bx bx-message-dots"></i>
                      <span>{props.t("Avis et Feedback des Clients")}</span>
                    </Link>
                  </li>
                </>
              )
            }


            {/*<li>
              <Link to="/faq">
                <i className="bx bx-help-circle"></i>
                <span>{props.t("Fàq")}</span>
              </Link>
            </li>*/}

            <li className="border-top mt-4 pt-2">
              <Link to="/logout">
                <i className="bx bx-log-out text-danger"></i>
                <span className="text-danger">{props.t("Se-déconnecter")}</span>
              </Link>
            </li>

          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
